// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3Nhr-","footer":"ModalError_footer__29FA_"};